module.exports = __webpack_public_path__ + "pdfs/Setup_Guide_new.pdf";